export default [
  { path: "/user", redirect: { name: "user-dashboard-profile" } },
  { path: "/user/dashboard", redirect: { name: "user-dashboard-profile" } },
];
